"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

require("./loader.css");

var Loader = function Loader() {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube-grid"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube1"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube2"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube3"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube4"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube5"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube6"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube7"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube8"
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sacd-cube sacd-cube9"
  }));
};

var _default = Loader;
exports.default = _default;